const MAX_SKU_LENGTH = 64;

/**
 * Deriva un SKU válido a partir del nombre del producto.
 * "Hamburguesa clásica" → "HAMBURGUESA-CLASICA"
 * Mismo algoritmo que en desktop (`apps/desktop/src/renderer/src/lib/sku.ts`)
 * — si se desea, en una iteración futura movemos este helper a `@atreus/core`.
 */
export const buildSku = (name: string): string =>
  name
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, MAX_SKU_LENGTH);
